import { useCallback, useMemo, useState } from "react";
import type { SeleccionInventario } from "../types/catalogoInventario.types";

export const useSeleccionInventario = (): SeleccionInventario => {
    const [ids, setIds] = useState<Set<number>>(() => new Set());

    const alternar = useCallback((id: number) => {
        setIds((prev) => {
            const nuevo = new Set(prev);
            if (nuevo.has(id)) nuevo.delete(id);
            else nuevo.add(id);
            return nuevo;
        });
    }, []);

    const marcarVarios = useCallback((lista: number[], marcar: boolean) => {
        setIds((prev) => {
            const nuevo = new Set(prev);
            lista.forEach((id) => (marcar ? nuevo.add(id) : nuevo.delete(id)));
            return nuevo;
        });
    }, []);

    const limpiar = useCallback(() => setIds(new Set()), []);

    return useMemo(
        () => ({
            lista: Array.from(ids),
            cantidad: ids.size,
            estaSeleccionado: (id: number) => ids.has(id),
            alternar,
            marcarVarios,
            limpiar,
        }),
        [ids, alternar, marcarVarios, limpiar]
    );
};
